/**
 * Shared SKU classification utilities
 */

/** Check if a SKU belongs to Amazon's Grade & Resell program */
export const isGradeResellSku = (sku: string): boolean => {
  const skuUpper = sku.toUpperCase();
  return skuUpper.startsWith('AMZN.GR') || skuUpper.startsWith('AMZN,GR');
};

/** Display label for the Grade & Resell aggregate group */
export const GRADE_RESELL_LABEL = 'Grade & Resell';
